import React from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ErrorPage from "./Views/ErrorPage/ErrorPage";
import Navbar from "./Components/Navbar-copy/Navbar";
import MalaysiaEvent from "./Views/MalaysiaEvent/MalaysiaEvent";
import BarcelonaEvent from "./Views/BarcelonaEvent/BarcelonaEvent";
import DubaiEvent from "./Views/DubaiEvent/DubaiEvent";
import ZixxarMaldiveEvent from "./Views/ZixxarMaldive/ZixxarMaldiveEvent.view";

import PageTracking from "./Utils/pageTracking";
import { useEffect } from "react";
import moment from "moment";

const App = () => {
  PageTracking();

  // useEffect(() => {
  //   console.log("timer");
  //   const currentUtcTime = moment.utc();

  //   // Set the target date and time to compare against (June 1, 00:00)
  //   const targetUtcTime = moment.utc("2023-12-3T09:00:00");

  //   // Check if the current UTC time has passed the target UTC time
  //   if (currentUtcTime.isAfter(targetUtcTime)) {
  //     setPastEvents(true);
  //   } else {
  //     setPastEvents(false);
  //   }
  // }, []);
  return (
    <div className="App position-relative">
      {/* global components */}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        // autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        closeButton={true}
      />

      {/* <Navbar /> */}

      {/* routes */}
      <Routes>
        {/* {pastEvents ? (
          <Route path="/" element={<DubaiEvent />} />
        ) : (
          <Route path="/" element={<BarcelonaEvent />} />
        )} */}
        {/* <Route path='/' element={<DubaiEvent />} /> */}
        <Route path="/" element={<ZixxarMaldiveEvent />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </div>
  );
};

export default App;
